import axios from 'axios';

import {OAuthClient, OAuthScope, CreateOAuthClientRequest, RegenerateSecretResponse} from 'types';

import {API_URL} from './constants';

const url = `${API_URL}/account-oauth`;

const getAll = async (): Promise<OAuthClient[]> => {
    const res = await axios.get(url);
    return res.data;
};

const getOne = async (id: string): Promise<OAuthClient> => {
    const res = await axios.get(`${url}/${id}`);
    return res.data;
};

const create = async (data: CreateOAuthClientRequest): Promise<RegenerateSecretResponse> => {
    const res = await axios.post(url, data);
    return res.data;
};

const update = async (id: string, data: CreateOAuthClientRequest): Promise<OAuthClient> => {
    const res = await axios.put(`${url}/${id}`, data);
    return res.data;
};

const regenerateSecret = async (id: string): Promise<RegenerateSecretResponse> => {
    const res = await axios.post(`${url}/${id}/regenerate-secret`);
    return res.data;
};

const deleteOne = async (id: string): Promise<void> => {
    await axios.delete(`${url}/${id}`);
};

const getAvailableScopes = async (): Promise<{scopes: OAuthScope[]}> => {
    const res = await axios.get(`${url}/available-scopes`);
    return res.data;
};

export const accountOAuthApi = {
    getAll,
    getOne,
    create,
    update,
    regenerateSecret,
    deleteOne,
    getAvailableScopes
};